import { Component, ChangeDetectionStrategy } from '@angular/core';

import { UIModule } from '@bannerflow/ui';

@Component({
    selector: 'app-oops',
    templateUrl: './oops.component.html',
    styleUrls: ['./oops.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [UIModule]
})
export class OopsComponent {}
